import { NavigateFunction } from "react-router-dom";

import { FilterKeys } from "@/components/type";
import { ROUTES } from "@/constants";
import { TabNames } from "@/pages/ChatbotMy/types";

interface getEmptyStateValueProps {
  searchedQuery: string;
  filterBy: FilterKeys;
  navigate: NavigateFunction;
  activeTab: TabNames;
  t: (key: string) => string;
}

type GetEmptyStateValueReturn = {
  title: string;
  description: string;
  buttonText?: string;
  onClick?: () => void;
};

export const getEmptyStateValue = ({
  searchedQuery,
  filterBy,
  navigate,
  activeTab,
  t = (key: string) => key,
}: getEmptyStateValueProps): GetEmptyStateValueReturn => {
  const NO_RESULT_OBJECT = {
    title: t("common:noResultsFound"),
  };

  if (searchedQuery || filterBy !== FilterKeys.ALL) {
    return {
      ...NO_RESULT_OBJECT,
      description: t("myCreation:emptyState.search.description"),
    };
  }

  switch (activeTab) {
    case TabNames.LOREBOOKS:
      return {
        ...NO_RESULT_OBJECT,
        description: t("myCreation:emptyState.lorebook.description"),
        buttonText: t("myCreation:emptyState.lorebook.buttonText"),
        onClick: () => navigate(ROUTES.lorebookCreate),
      };
    case TabNames.GROUPS:
      return {
        ...NO_RESULT_OBJECT,
        description: t("myCreation:emptyState.groupchat.description"),
        buttonText: t("myCreation:emptyState.groupchat.buttonText"),
        onClick: () => navigate(ROUTES.groupchatCreate),
      };
    case TabNames.VOICES:
      return {
        ...NO_RESULT_OBJECT,
        description: t("myCreation:emptyState.voice.description"),
        buttonText: t("myCreation:emptyState.voice.buttonText"),
        onClick: () => navigate(ROUTES.voiceCreate),
      };
  }

  return {
    ...NO_RESULT_OBJECT,
    description: t("myCreation:emptyState.default.description"),
    buttonText: t("myCreation:emptyState.default.buttonText"),
    onClick: () => navigate(ROUTES.createChatbot),
  };
};
